<template>
  <div>
    <megabit-base-dialog :show-dialog="true" :width="formWidth">
      <template v-slot:body>
        <v-sheet v-if="isLoading" class="pa-3" dark>
          <v-skeleton-loader
            class="mx-auto"
            :max-width="formWidth"
            max-height="768"
            type="card"
          ></v-skeleton-loader>
        </v-sheet>
        <v-card dark v-else>
          <v-card-title class="align-self-center">
            <span class="text-h6">Cadastro de Obras (alt+r)</span>
          </v-card-title>
          <v-card-text>
            <v-tabs v-model="tab" :grow="true">
              <v-tabs-slider color="red"></v-tabs-slider>

              <v-tab>Dados</v-tab>
              <v-tab>Fases</v-tab>
              <v-tab>Lançamentos</v-tab>
              <v-tab>Parcelamentos</v-tab>

              <v-tabs-items v-model="tab" :transition="false">
                <v-tab-item :transition="false">
                  <v-card dark>
                    <v-card-text>
                      <v-row dense>
                        <v-col>
                          <v-form ref="form" v-model="formValid">
                            <v-row dense>
                              <v-col
                                cols="2"
                                sm="2"
                                md="1"
                                lg="1"
                                style="min-width: 100px; max-width: 100%;"
                                class="flex-grow-0 flex-shrink-0"
                              >
                                <c-input
                                  label="Código"
                                  placeholder="Código"
                                  :maxLength="6"
                                  v-model.trim="form.codigo"
                                />
                              </v-col>
                              <v-spacer></v-spacer>
                              <div>
                                <span>{{ form.usuarioAlteracao }}</span>
                              </div>
                            </v-row>
                            <v-row dense>
                              <v-col cols="12" sm="6" md="4" lg="4">
                                <c-input
                                  label="Descrição"
                                  placeholder="Digite a Descrição"
                                  :maxLength="35"
                                  :minLength="3"
                                  :isRequired="true"
                                  v-model.trim="form.nome"
                                />
                              </v-col>
                              <v-col cols="5" sm="3" md="2" lg="2">
                                <v-text-field
                                  v-model="form.data"
                                  type="date"
                                  class="text-caption unstyled"
                                  style="width: 110px"
                                  label="Data"
                                  persistent-hint
                                  dark
                                  dense
                                  outlined
                                />
                              </v-col>
                              <v-col cols="5" sm="3" md="2" lg="2">
                                <v-text-field
                                  v-model="form.previsaoConclusao"
                                  type="date"
                                  class="text-caption unstyled"
                                  style="width: 110px"
                                  label="Prev. Conclusão"
                                  persistent-hint
                                  dark
                                  dense
                                  outlined
                                />
                              </v-col>
                              <v-col cols="5" sm="2" md="2" lg="2">
                                <c-input
                                  v-model="form.latitude"
                                  label="Latitude"
                                  placeholder="Latitude"
                                  :maxLength="18"
                                />
                              </v-col>
                              <v-col cols="5" sm="2" md="2" lg="2">
                                <c-input
                                  v-model="form.longitude"
                                  label="Longitude"
                                  placeholder="Longitude"
                                  :maxLength="18"
                                />
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col cols="5" sm="2" md="2" lg="2">
                                <c-input
                                  v-model="form.cep"
                                  label="CEP"
                                  placeholder="Digite o CEP"
                                  :maxLength="8"
                                />
                              </v-col>
                              <v-col cols="12" sm="6" md="6" lg="6">
                                <c-input
                                  v-model="form.endereco"
                                  label="Endereço"
                                  placeholder="Digite o endereco"
                                  :maxLength="45"
                                />
                              </v-col>
                              <v-col cols="6" sm="4" md="4" lg="4">
                                <c-input
                                  v-model="form.bairro"
                                  label="Bairro"
                                  placeholder="Digite o Bairro"
                                  :maxLength="45"
                                ></c-input>
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col cols="10" sm="6" md="6" lg="3">
                                <v-combobox
                                  :items="cidadeList"
                                  v-model="form.cidade"
                                  item-text="DESCRICAO"
                                  item-value="CODIGO"
                                  label="Cidade"
                                  class="text-caption"
                                  placeholder="Cidade"
                                  @update:search-input="
                                    searchCity($event, 'cidade')
                                  "
                                  @input="updateUF"
                                  outlined
                                  dense
                                />
                              </v-col>
                              <v-col cols="2" sm="2" md="1" lg="1">
                                <c-input
                                  v-model="form.uf"
                                  label="UF"
                                  placeholder="UF"
                                  :maxLength="2"
                                />
                              </v-col>
                              <v-col cols="6" sm="3" md="3" lg="2">
                                <c-input
                                  v-model="form.fone"
                                  label="Telefone"
                                  placeholder="Telefone"
                                  :maxLength="16"
                                />
                              </v-col>
                              <v-col cols="6" sm="3" md="3" lg="2">
                                <c-input
                                  v-model="form.fone1"
                                  label="Telefone 2"
                                  placeholder="Telefone"
                                  :maxLength="16"
                                />
                              </v-col>
                              <v-col cols="12" sm="4" md="4" lg="4">
                                <c-input
                                  v-model="form.contato"
                                  label="Contato"
                                  placeholder="Contato"
                                  :maxLength="16"
                                />
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col cols="12" sm="6" md="6" lg="6">
                                <c-select
                                  item-text="DESCRICAO"
                                  item-value="CODIGO"
                                  :lista="empresaList"
                                  :item.sync="form.empresa"
                                  rotulo="Empresa"
                                  @searchinput="search($event, 'empresa')"
                                />
                              </v-col>
                              <v-col
                                cols="6"
                                sm="3"
                                md="3"
                                lg="3"
                                v-if="regiaoList.length > 0"
                              >
                                <c-select
                                  :lista="regiaoList"
                                  :item.sync="form.regiao"
                                  itemText="text"
                                  itemValue="value"
                                  rotulo="Região"
                                />
                              </v-col>
                              <v-col
                                cols="6"
                                sm="3"
                                md="3"
                                lg="3"
                                v-if="rotaList.length > 0"
                              >
                                <c-select
                                  :lista="rotaList"
                                  :item.sync="form.rota"
                                  itemText="text"
                                  itemValue="value"
                                  rotulo="Rota"
                                />
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col cols="12" sm="6" md="6" lg="6">
                                <c-select
                                  item-text="DESCRICAO"
                                  item-value="CODIGO"
                                  :lista="arquitetoList"
                                  :item.sync="form.arquiteto"
                                  rotulo="Arquiteto"
                                  @searchinput="search($event, 'arquiteto')"
                                />
                              </v-col>
                              <v-col cols="12" sm="6" md="6" lg="6">
                                <c-select
                                  item-text="DESCRICAO"
                                  item-value="CODIGO"
                                  :lista="engenheiroList"
                                  :item.sync="form.engenheiro"
                                  rotulo="Engenheiro"
                                  @searchinput="search($event, 'engenheiro')"
                                />
                              </v-col>
                            </v-row>
                            <v-row dense class="mt-1">
                              <v-col cols="4" sm="2" md="2" lg="2">
                                <c-input
                                  v-model.number="form.area"
                                  type="number"
                                  label="Área"
                                  placeholder="Área em m²"
                                />
                              </v-col>
                              <v-col cols="4" sm="2" md="2" lg="2">
                                <c-select
                                  :lista="optionMaterial"
                                  :item.sync="form.materialDisponivel"
                                  itemText="text"
                                  itemValue="value"
                                  rotulo="Material Disp?"
                                />
                              </v-col>
                              <v-col cols="4" sm="3" md="3" lg="3">
                                <c-select
                                  :lista="tipoList"
                                  :item.sync="form.tipo"
                                  itemText="text"
                                  itemValue="value"
                                  rotulo="Tipo"
                                />
                              </v-col>
                              <v-col cols="6" sm="3" md="3" lg="3">
                                <c-select
                                  :lista="tipoEdificacaoList"
                                  :item.sync="form.tipoEdificacao"
                                  itemText="text"
                                  itemValue="value"
                                  rotulo="Tipo Edificação"
                                />
                              </v-col>
                              <v-col cols="6" sm="2" md="2" lg="2">
                                <c-select
                                  :lista="origemClienteList"
                                  :item.sync="form.origemCliente"
                                  itemText="text"
                                  itemValue="value"
                                  rotulo="Origem"
                                />
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <c-input
                                  v-model.trim="form.horarioEntrega"
                                  label="Período Entrega"
                                  placeholder="Horário/Período Entrega"
                                  :maxLength="80"
                                />
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col>
                                <v-textarea
                                  v-model.trim="form.observacao"
                                  outlined
                                  class="text-caption"
                                  name="input"
                                  label="Observação"
                                  placeholder="Digite uma Observação"
                                  maxlength="5000"
                                ></v-textarea>
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col>
                                <div class="rounded text secondary">
                                  <span class="ml-2">Status</span>
                                  <v-radio-group
                                    v-model="form.status"
                                    dense
                                    row
                                  >
                                    <v-radio
                                      v-for="status in statusList"
                                      :key="status.value"
                                      :label="status.text"
                                      :value="status.value"
                                      dense
                                      class="customClass"
                                    ></v-radio>
                                  </v-radio-group>
                                </div>
                              </v-col>
                            </v-row>
                            <v-row dense class="py-4">
                              <v-col cols="6" sm="4" md="4" lg="3">
                                <v-text-field
                                  v-model="form.dataConclusao"
                                  type="date"
                                  class="text-caption unstyled"
                                  style="width: 110px"
                                  label="Data Conclusão"
                                  persistent-hint
                                  dark
                                  dense
                                  outlined
                                />
                              </v-col>
                              <v-col cols="6" sm="4" md="4" lg="3">
                                <v-text-field
                                  v-model.trim="form.usuario"
                                  label="Usuário"
                                  placeholder="Usuário"
                                  :readonly="true"
                                  class="text-caption"
                                  dense
                                  outlined
                                />
                              </v-col>
                              <v-spacer></v-spacer>
                              <v-col cols="12" sm="4" md="4" lg="3">
                                <c-input-money
                                  v-model="totalObra"
                                  label="Total Obra"
                                  placeholder="Total Obra"
                                  :class="''"
                                  dark
                                  dense
                                  outlined
                                  reverse
                                  v-bind:valueWhenIsEmpty="'0'"
                                  v-bind:options="{
                                    locale: 'pt-BR',
                                    prefix: '',
                                    suffix: '',
                                    length: 11,
                                    precision: getPrecision(),
                                  }"
                                />
                              </v-col>
                            </v-row>
                          </v-form>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <!-- FASES  -->
                  <v-card dark>
                    <v-card-text>
                      <v-row dense>
                        <v-col>
                          <!-- @item-selected="selectFase($event)" -->
                          <v-data-table
                            v-model="selectedFases"
                            :headers="headerFases"
                            :items="indexedFasesList"
                            item-key="id"
                            show-select
                            dense
                            no-data-text="Sem registros para exibir"
                            sort-by.sync="FASE"
                          >
                            <template v-slot:top>
                              <v-toolbar flat>
                                <v-toolbar-title>Fases</v-toolbar-title>
                                <v-divider
                                  class="mx-4"
                                  inset
                                  vertical
                                ></v-divider>
                                <v-spacer></v-spacer>
                                <v-dialog
                                  v-model="dialogTabFase"
                                  max-width="500px"
                                  transition="dialog-bottom-transition"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      color="primary"
                                      dark
                                      class="mb-2"
                                      v-bind="attrs"
                                      v-on="on"
                                      :disabled="!isHabilitarEdicao"
                                    >
                                      Novo
                                    </v-btn>
                                  </template>
                                  <v-card dark>
                                    <v-card-title>
                                      <span class="headline">Fase</span>
                                    </v-card-title>
                                    <v-card-text>
                                      <v-container>
                                        <v-form
                                          ref="formFase"
                                          v-model="tabFaseValid"
                                        >
                                          <v-row dense>
                                            <v-col
                                              cols="6"
                                              sm="2"
                                              md="2"
                                              lg="2"
                                            >
                                              <c-input
                                                label="Código"
                                                placeholder="Código"
                                                :readonly="true"
                                                v-model.trim="tabFase.codigo"
                                                :maxLength="8"
                                              />
                                            </v-col>
                                            <v-col cols="9" lg="10">
                                              <c-input
                                                label="Fase"
                                                placeholder="Nome da Fase"
                                                :isRequired="true"
                                                v-model.trim="tabFase.nomeFase"
                                                :maxLength="40"
                                              />
                                            </v-col>
                                          </v-row>
                                        </v-form>
                                      </v-container>
                                    </v-card-text>
                                    <form-buttons
                                      @goBack="closeTabFase()"
                                      @submitForm="addFase()"
                                      :disabled-save="!isHabilitarEdicao"
                                    />
                                  </v-card>
                                </v-dialog>
                              </v-toolbar>
                            </template>
                            <template
                              v-for="(header, index) in headerFases"
                              v-slot:[`item.${header.value}`]="{ item }"
                            >
                              <div
                                v-if="header.value === 'controls'"
                                :key="index"
                              >
                                <v-btn-toggle tile>
                                  <v-btn
                                    class="mr-1"
                                    fab
                                    x-small
                                    color="warning"
                                    @click="updateTabFase(item)"
                                    :disabled="!isHabilitarVisualizacao"
                                  >
                                    <v-icon dark>mdi-pen</v-icon>
                                  </v-btn>
                                  <v-btn
                                    fab
                                    x-small
                                    color="error"
                                    @click="deleteFase(item, false)"
                                    :disabled="!isHabilitarEdicao"
                                  >
                                    <v-icon dark>mdi-delete</v-icon>
                                  </v-btn>
                                </v-btn-toggle>
                              </div>
                              <div v-else :key="index">
                                <td
                                  :class="
                                    item.SEQUENCIALRELACIONAMENTO > 0
                                      ? estiloLinhaFaturada
                                      : 'font-weight-regular'
                                  "
                                >
                                  {{ item[header.value] }}
                                </td>
                              </div>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                      <v-row dense>
                        <v-tabs>
                          <!-- FASESITENS  -->
                          <v-tabs-slider color="red"></v-tabs-slider>
                          <v-tab>Aplicações</v-tab>
                          <v-tab-item>
                            <v-card dark>
                              <v-card-text>
                                <v-data-table
                                  :headers="headerFaseItens"
                                  :items="indexedFasesItensList"
                                  item-key="id"
                                  :show-select="true"
                                  :single-select="true"
                                  @item-selected="selectFaseItem($event)"
                                  no-data-text="Sem registros para exibir"
                                >
                                  <template v-slot:top>
                                    <v-toolbar flat>
                                      <v-toolbar-title
                                        >Aplicações</v-toolbar-title
                                      >
                                      <v-divider
                                        class="mx-4"
                                        inset
                                        vertical
                                      ></v-divider>
                                      <v-spacer></v-spacer>
                                      <v-toolbar-title>
                                        {{
                                          selectedFase
                                            ? selectedFase.NOMEFASE
                                            : ''
                                        }}
                                      </v-toolbar-title>
                                      <v-spacer></v-spacer>
                                      <v-dialog
                                        v-model="dialogTabFaseItem"
                                        max-width="500px"
                                        transition="dialog-bottom-transition"
                                      >
                                        <template
                                          v-slot:activator="{ on, attrs }"
                                        >
                                          <v-btn
                                            color="primary"
                                            dark
                                            class="mb-2"
                                            v-bind="attrs"
                                            v-on="on"
                                            :disabled="!isHabilitarEdicao"
                                          >
                                            Novo
                                          </v-btn>
                                        </template>
                                        <v-card dark>
                                          <v-card-title>
                                            <span class="headline"
                                              >Aplicação</span
                                            >
                                          </v-card-title>
                                          <v-card-text>
                                            <v-container>
                                              <v-form
                                                ref="formFaseItem"
                                                v-model="tabFaseItemValid"
                                              >
                                                <v-row dense>
                                                  <v-col>
                                                    <c-select
                                                      :lista="produtoList"
                                                      :item.sync="
                                                        tabFaseItem.item
                                                      "
                                                      itemText="DESCRICAO"
                                                      itemValue="CODIGO"
                                                      rotulo="Produto"
                                                      @searchinput="
                                                        searchItems(
                                                          $event,
                                                          'produto'
                                                        )
                                                      "
                                                    />
                                                  </v-col>
                                                </v-row>
                                                <v-row dense>
                                                  <v-col
                                                    cols="6"
                                                    sm="4"
                                                    md="3"
                                                    lg="3"
                                                  >
                                                    <v-select
                                                      v-model="
                                                        tabFaseItem.tipoPreco
                                                      "
                                                      :items="typePriceList"
                                                      class="text-caption"
                                                      item-text="descricao"
                                                      item-value="id"
                                                      label="Tipo Preço"
                                                      persistent-hint
                                                      dense
                                                      dark
                                                      outlined
                                                    />
                                                  </v-col>
                                                  <v-col
                                                    cols="6"
                                                    sm="4"
                                                    md="3"
                                                    lg="3"
                                                  >
                                                    <c-input
                                                      label="Quantidade"
                                                      placeholder="Quantidade"
                                                      type="number"
                                                      :isRequired="true"
                                                      v-model.number="
                                                        tabFaseItem.quantidade
                                                      "
                                                    />
                                                  </v-col>
                                                  <v-col
                                                    cols="6"
                                                    sm="4"
                                                    md="3"
                                                    lg="3"
                                                  >
                                                    <c-input
                                                      label="Qtd. Aplicada"
                                                      placeholder="Quantidade"
                                                      type="number"
                                                      v-model.number="
                                                        tabFaseItem.quantidadeAplicada
                                                      "
                                                      :readonly="true"
                                                    />
                                                  </v-col>
                                                  <v-col
                                                    cols="6"
                                                    sm="4"
                                                    md="3"
                                                    lg="3"
                                                  >
                                                    <c-input
                                                      label="Ordem"
                                                      placeholder="Ordem"
                                                      type="number"
                                                      v-model.number="
                                                        tabFaseItem.seq
                                                      "
                                                    />
                                                  </v-col>
                                                </v-row>
                                                <v-row dense>
                                                  <v-col cols="6">
                                                    <c-input-money
                                                      v-model="
                                                        cmpPrecoItemPeloTipo
                                                      "
                                                      label="Total"
                                                      dark
                                                      dense
                                                      outlined
                                                      reverse
                                                      readonly
                                                      v-bind:valueWhenIsEmpty="
                                                        '0'
                                                      "
                                                      v-bind:options="{
                                                        locale: 'pt-BR',
                                                        prefix: '',
                                                        suffix:
                                                          tabFaseItem.preffix,
                                                        length: 11,
                                                        precision: getPrecision(),
                                                      }"
                                                    />
                                                  </v-col>
                                                  <v-col cols="6">
                                                    <c-input-money
                                                      v-model="cmpTotalFaseItem"
                                                      label="Total"
                                                      dark
                                                      dense
                                                      outlined
                                                      reverse
                                                      readonly
                                                      v-bind:valueWhenIsEmpty="
                                                        '0'
                                                      "
                                                      v-bind:options="{
                                                        locale: 'pt-BR',
                                                        prefix: '',
                                                        suffix:
                                                          tabFaseItem.preffix,
                                                        length: 11,
                                                        precision: getPrecision(),
                                                      }"
                                                    />
                                                  </v-col>
                                                </v-row>
                                              </v-form>
                                            </v-container>
                                          </v-card-text>
                                          <form-buttons
                                            @goBack="closeTabFaseItem()"
                                            @submitForm="addFaseItem()"
                                            :disabled-save="!isHabilitarEdicao"
                                          />
                                        </v-card>
                                      </v-dialog>
                                    </v-toolbar>
                                  </template>
                                  <template
                                    v-for="(header, index) in headerFaseItens"
                                    v-slot:[`item.${header.value}`]="{ item }"
                                  >
                                    <div
                                      v-if="header.value === 'calculated'"
                                      :key="index"
                                    >
                                      {{
                                        formatValuesByTypeCurrency(
                                          item['TIPOPRECO'],
                                          item,
                                          multiplicar(
                                            item['QUANTIDADE'],
                                            item['VALOR']
                                          )
                                        )
                                      }}
                                    </div>
                                    <div
                                      v-else-if="header.value === 'VALOR'"
                                      :key="index"
                                    >
                                      {{
                                        formatValuesByTypeCurrency(
                                          item['TIPOPRECO'],
                                          item,
                                          item['VALOR']
                                        )
                                      }}
                                    </div>
                                    <div
                                      v-else-if="header.value === 'controls'"
                                      :key="index"
                                    >
                                      <div>
                                        <v-btn-toggle tile>
                                          <v-btn
                                            class="mr-1"
                                            fab
                                            x-small
                                            color="warning"
                                            @click="updateTabFaseItem(item)"
                                            :disabled="!isHabilitarVisualizacao"
                                          >
                                            <v-icon dark>mdi-pen</v-icon>
                                          </v-btn>
                                          <v-btn
                                            fab
                                            x-small
                                            color="error"
                                            @click="deleteFaseItem(item, false)"
                                            :disabled="!isHabilitarEdicao"
                                          >
                                            <v-icon dark>mdi-delete</v-icon>
                                          </v-btn>
                                        </v-btn-toggle>
                                      </div>
                                    </div>
                                    <div v-else :key="index">
                                      {{ item[header.value] }}
                                    </div>
                                  </template>
                                </v-data-table>
                              </v-card-text>
                              <v-card-text>
                                <v-row>
                                  <v-spacer></v-spacer>
                                  <v-col cols="12" sm="6" md="6" lg="3">
                                    <c-input-money
                                      v-model="totalFase"
                                      label="Total Fase"
                                      placeholder="Total Fase"
                                      dark
                                      dense
                                      outlined
                                      reverse
                                      readonly
                                      v-bind:valueWhenIsEmpty="'0'"
                                      v-bind:options="{
                                        locale: 'pt-BR',
                                        prefix: '',
                                        suffix: '',
                                        length: 11,
                                        precision: getPrecision(),
                                      }"
                                    />
                                  </v-col>
                                </v-row>
                              </v-card-text>
                              <v-card-text>
                                <v-data-table
                                  :headers="headerAplicacao"
                                  :items="indexedAplicacaoList"
                                  item-key="id"
                                  :show-select="true"
                                  :single-select="true"
                                  @item-selected="selectAplicacao($event)"
                                  no-data-text="Sem registros para exibir"
                                >
                                  <template v-slot:top>
                                    <v-toolbar flat>
                                      <v-toolbar-title
                                        >Previsão Aplicação</v-toolbar-title
                                      >
                                      <v-divider
                                        class="mx-4"
                                        inset
                                        vertical
                                      ></v-divider>
                                      <v-spacer></v-spacer>
                                      <v-dialog
                                        v-model="dialogTabAplicacao"
                                        max-width="500px"
                                        transition="dialog-bottom-transition"
                                      >
                                        <template
                                          v-slot:activator="{ on, attrs }"
                                        >
                                          <v-btn
                                            color="primary"
                                            dark
                                            class="mb-2"
                                            v-bind="attrs"
                                            v-on="on"
                                            :disabled="!isHabilitarEdicao"
                                          >
                                            Novo
                                          </v-btn>
                                        </template>
                                        <v-card dark>
                                          <v-card-title>
                                            <span class="headline"
                                              >Previsão Aplicação</span
                                            >
                                          </v-card-title>
                                          <v-card-text>
                                            <v-container>
                                              <v-form
                                                ref="formAplicacao"
                                                v-model="tabAplicacaoValid"
                                              >
                                                <v-row dense>
                                                  <v-col cols="6" lg="3">
                                                    <v-text-field
                                                      v-model="
                                                        tabAplicacao.dataPrevisao
                                                      "
                                                      type="date"
                                                      class="text-caption unstyled"
                                                      style="width: 110px"
                                                      label="Prev. Aplicação"
                                                      persistent-hint
                                                      dark
                                                      dense
                                                      outlined
                                                    />
                                                  </v-col>
                                                  <v-col cols="6" lg="3">
                                                    <v-text-field
                                                      v-model.number="
                                                        tabAplicacao.quantidade
                                                      "
                                                      label="Quantidade"
                                                      placeholder="Quantidade"
                                                      type="number"
                                                      class="text-caption"
                                                      min="0"
                                                      max="4"
                                                      required
                                                      persistent-hint
                                                      dark
                                                      dense
                                                      outlined
                                                    />
                                                  </v-col>
                                                </v-row>
                                              </v-form>
                                            </v-container>
                                          </v-card-text>
                                          <form-buttons
                                            @goBack="closeTabAplicacao()"
                                            @submitForm="addAplicacao()"
                                            :disabled-save="!isHabilitarEdicao"
                                          />
                                        </v-card>
                                      </v-dialog>
                                    </v-toolbar>
                                  </template>
                                  <template
                                    v-for="(header, index) in headerAplicacao"
                                    v-slot:[`item.${header.value}`]="{ item }"
                                  >
                                    <div
                                      v-if="header.value.indexOf('DATA') !== -1"
                                      :key="index"
                                    >
                                      {{ formatDateFromDB(item[header.value]) }}
                                    </div>
                                    <div
                                      v-else-if="header.value === 'controls'"
                                      :key="index"
                                    >
                                      <div>
                                        <v-btn-toggle tile>
                                          <v-btn
                                            class="mr-1"
                                            fab
                                            x-small
                                            color="warning"
                                            @click="updateTabAplicacao(item)"
                                            :disabled="!isHabilitarVisualizacao"
                                          >
                                            <v-icon dark>mdi-pen</v-icon>
                                          </v-btn>
                                          <v-btn
                                            fab
                                            x-small
                                            color="error"
                                            @click="
                                              deleteAplicacao(item, false)
                                            "
                                            :disabled="!isHabilitarEdicao"
                                          >
                                            <v-icon dark>mdi-delete</v-icon>
                                          </v-btn>
                                        </v-btn-toggle>
                                      </div>
                                    </div>
                                    <div v-else :key="index">
                                      {{ item[header.value] }}
                                    </div>
                                  </template>
                                </v-data-table>
                              </v-card-text>
                            </v-card>
                          </v-tab-item>
                          <!-- COMISSOES  -->
                          <v-tab>Comissões</v-tab>
                          <v-tab-item>
                            <v-card dark>
                              <v-card-text>
                                <v-data-table
                                  :headers="headerComissoes"
                                  :items="indexedComissoesList"
                                  item-key="id"
                                  :show-select="true"
                                  :single-select="true"
                                  @item-selected="selectComissao($event)"
                                  no-data-text="Sem registros para exibir"
                                >
                                  <template v-slot:top>
                                    <v-toolbar flat>
                                      <v-toolbar-title
                                        >Comissões</v-toolbar-title
                                      >
                                      <v-divider
                                        class="mx-4"
                                        inset
                                        vertical
                                      ></v-divider>
                                      <v-spacer></v-spacer>
                                      <v-dialog
                                        v-model="dialogTabComissao"
                                        max-width="500px"
                                        transition="dialog-bottom-transition"
                                      >
                                        <template
                                          v-slot:activator="{ on, attrs }"
                                        >
                                          <v-btn
                                            color="primary"
                                            dark
                                            class="mb-2"
                                            v-bind="attrs"
                                            v-on="on"
                                            :disabled="!isHabilitarEdicao"
                                          >
                                            Novo
                                          </v-btn>
                                        </template>
                                        <v-card dark>
                                          <v-card-title>
                                            <span class="headline"
                                              >Comissão</span
                                            >
                                          </v-card-title>
                                          <v-card-text>
                                            <v-container>
                                              <v-form
                                                ref="formComissao"
                                                v-model="tabComissaoValid"
                                              >
                                                <v-row dense>
                                                  <v-col cols="12">
                                                    <c-select
                                                      item-text="DESCRICAO"
                                                      item-value="CODIGO"
                                                      rotulo="Vendedor"
                                                      :lista="usersList"
                                                      :item.sync="
                                                        tabComissao.vendedor
                                                      "
                                                      v-model="
                                                        tabComissao.vendedor
                                                      "
                                                    />
                                                  </v-col>
                                                  <v-col cols="3">
                                                    <c-input
                                                      label="Percentual"
                                                      type="number"
                                                      placeholder=" % comissão"
                                                      :maxLength="10"
                                                      :isRequired="true"
                                                      v-model.number="
                                                        tabComissao.percentual
                                                      "
                                                    />
                                                  </v-col>
                                                  <v-col cols="3">
                                                    <v-autocomplete
                                                      :items="['V', 'C']"
                                                      v-model="tabComissao.tipo"
                                                      label="Tipo"
                                                      class="text-caption"
                                                      placeholder="V/C"
                                                      clearable
                                                      outlined
                                                      dense
                                                    />
                                                  </v-col>
                                                </v-row>
                                              </v-form>
                                            </v-container>
                                          </v-card-text>
                                          <form-buttons
                                            @goBack="closeTabComissao()"
                                            @submitForm="addComissao()"
                                            :disabled-save="!isHabilitarEdicao"
                                          />
                                        </v-card>
                                      </v-dialog>
                                    </v-toolbar>
                                  </template>
                                  <template #item.controls="{item}">
                                    <div>
                                      <v-btn-toggle tile>
                                        <v-btn
                                          class="mr-1"
                                          fab
                                          x-small
                                          color="warning"
                                          @click="updateTabComissao(item)"
                                          :disabled="!isHabilitarVisualizacao"
                                        >
                                          <v-icon dark>mdi-pen</v-icon>
                                        </v-btn>
                                        <v-btn
                                          fab
                                          x-small
                                          color="error"
                                          @click="deleteComissao(item, false)"
                                          :disabled="!isHabilitarEdicao"
                                        >
                                          <v-icon dark>mdi-delete</v-icon>
                                        </v-btn>
                                      </v-btn-toggle>
                                    </div>
                                  </template>
                                </v-data-table>
                              </v-card-text>
                            </v-card>
                          </v-tab-item>
                        </v-tabs>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <!-- LANCAMENTOS -->
                  <v-card dark>
                    <v-card-title>
                      Orçamentos
                    </v-card-title>
                    <v-card-text>
                      <v-data-table
                        :headers="headerOrcamentos"
                        :items="form.orcamentos"
                        show-expand
                        fixed-header
                        item-key="SEQUENCIAL"
                        dense
                        no-data-text="Sem registros para exibir"
                      >
                        <template
                          v-for="(header, index) in headerOrcamentos"
                          v-slot:[`item.${header.value}`]="{ item }"
                        >
                          <div
                            v-if="header.value.indexOf('DATA') !== -1"
                            :key="index"
                          >
                            {{ formatDateFromDB(item[header.value]) }}
                          </div>
                          <div
                            v-else-if="
                              currencyFieldNames.lastIndexOf(header.value) !==
                                -1
                            "
                            :key="index"
                          >
                            {{
                              item[header.value]
                                ? formatValues(
                                    item[header.value],
                                    item['MOEDA']
                                  )
                                : null
                            }}
                          </div>
                          <div
                            v-else-if="
                              header.value == 'FASE' &&
                                item[header.value] !== null
                            "
                            :key="index"
                          >
                            {{ getDescricaoFase(item[header.value]) }}
                          </div>
                          <div v-else :key="index">
                            {{ item[header.value] }}
                          </div>
                        </template>

                        <template #expanded-item="{headers, item}">
                          <td
                            :colspan="headers.length"
                            class="pa-1 accent text-no-wrap"
                          >
                            <v-data-table
                              :headers="headerItensOrcamento"
                              :items="item.itens"
                              fixed-header
                              item-key="SEQUENCIAL"
                              :single-select="true"
                              dense
                              no-data-text="Sem registros para exibir"
                            >
                              <template
                                v-for="(header, index) in headerItensOrcamento"
                                v-slot:[`item.${header.value}`]="{ item }"
                              >
                                <div
                                  v-if="
                                    currencyFieldNames.lastIndexOf(
                                      header.value
                                    ) !== -1
                                  "
                                  :key="index"
                                >
                                  {{
                                    item[header.value]
                                      ? formatValues(
                                          item[header.value],
                                          item['SEQUENCIALORCAMENTO'],
                                          true
                                        )
                                      : null
                                  }}
                                </div>
                                <div
                                  v-else-if="header.value == 'item.DESCRICAO'"
                                  :key="index"
                                >
                                  <!-- bug no item[header.value] não entende o objeto item.DESCRICAO necessário  -->
                                  {{ item.item ? item.item.DESCRICAO : '' }}
                                </div>
                                <div v-else :key="index">
                                  {{ item[header.value] }}
                                </div>
                              </template>
                            </v-data-table>
                          </td>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <!-- PARCELAMENTOS -->
                  <v-card dark>
                    <v-card-text>
                      <v-data-table
                        :headers="headerParcelamentos"
                        :items="form.parcelamentos"
                        fixed-header
                        dense
                      >
                        <template v-slot:top>
                          <v-toolbar flat>
                            <v-toolbar-title>Parcelamentos</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>

                            <template>
                              <v-btn
                                color="primary"
                                dark
                                class="mb-2"
                                :disabled="!isHabilitarEdicao"
                                @click="newParcel"
                              >
                                Novo
                              </v-btn>
                              <parcelamento
                                :tabParcelamentoValid.sync="
                                  tabParcelamentoValid
                                "
                                :visible="dialogTabParcelamento"
                                :tabParcelamento="tabParcelamento"
                                :isHabilitarEdicao="isHabilitarEdicao"
                                :addParcelamento="addParcelamento"
                                @close="closeTabParcelamento"
                              />
                            </template>
                          </v-toolbar>
                        </template>

                        <template
                          v-for="(header, index) in headerParcelamentos"
                          v-slot:[`item.${header.value}`]="{ item }"
                        >
                          <div
                            v-if="
                              currencyFieldNames.lastIndexOf(header.value) !==
                                -1
                            "
                            :key="index"
                          >
                            {{
                              item[header.value]
                                ? formatValues(
                                    item[header.value],
                                    item['MOEDA']
                                  )
                                : null
                            }}
                          </div>
                          <div
                            v-else-if="header.value.indexOf('DATA') !== -1"
                            :key="index"
                          >
                            {{
                              item[header.value]
                                ? new Date(
                                    item[header.value] + '-03:00'
                                  ).toLocaleDateString('pt-BR')
                                : null
                            }}
                          </div>
                          <div
                            v-else-if="header.value === 'controls'"
                            :key="index"
                          >
                            <v-btn
                              fab
                              x-small
                              color="error"
                              @click="deleteParcelamento(item, false)"
                              :disabled="false"
                            >
                              <v-icon dark>mdi-delete</v-icon>
                            </v-btn>
                          </div>
                          <div v-else :key="index">
                            {{ item[header.value] }}
                          </div>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-tabs>
          </v-card-text>
          <form-buttons
            @goBack="goBack()"
            @submitForm="submitForm(form)"
            :disabled-save="!isHabilitarEdicao"
          />
        </v-card>
      </template>
    </megabit-base-dialog>
    <confirm ref="confirm" v-model="confirm"></confirm>
  </div>
</template>

<script>
// componentes
import Confirm from '@/components/shared/base-dialog/Confirm.vue'
import MegabitBaseDialog from '@/components/shared/base-dialog/BaseDialog'
import cSelect from '@/components/shared/base-input/BaseSelect.vue'
import cInput from '@/components/shared/base-input/BaseInput.vue'
import cInputMoney from '@/components/shared/base-input/BaseInputMoney.vue'
import Parcelamento from '@/views/parcel/Register.vue'
import FormButtons from '@/components/shared/base-buttons/FormButtons'
// import { formataDataBD } from '@/utils/utils'

import { formRegisterMixin } from '@/mixins/component/form/FormRegisterMixin'
import { tableMixin } from '@/mixins/component/table/TableMixin'
import { currencyMixin } from '@/mixins/object/currency/CurrencyMixin'

import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'FormRegisterConstruction',
  mixins: [formRegisterMixin, tableMixin, currencyMixin],
  components: {
    cSelect,
    MegabitBaseDialog,
    cInput,
    cInputMoney,
    Confirm,
    Parcelamento,
    FormButtons,
  },

  data: () => ({
    estiloLinhaFaturada: 'green--text font-weight-bold',
    selectedFases: [],
    timer: null,
    confirm: false,
    formWidth: 800,
    currencyFieldNames:
      'PRECO, VALOR, VALORTOTAL, VALORDESCONTOUNITARIO, VALORDESCONTO, VALORPAGO',
    isHabilitarEdicao: true, // SOMENTE LIBERAR CONSULTA ATÉ QUANDO FINALIZAR O CRUD
    isHabilitarVisualizacao: true,
    tab: null,
    optionMaterial: [
      { text: 'Sim', value: 'S' },
      { text: 'Não', value: 'N' },
    ],
    planoContaList: [],
    cidadeList: [],
    regiaoList: [],
    rotaList: [],
    produtoList: [],
    engenheiroList: [],
    arquitetoList: [],
    empresaList: [],
    tipoVendaList: [],
    form: {
      codigo: null,
      nome: null,
      empresa: undefined,
      engenheiro: undefined,
      arquiteto: undefined,
      data: null,
      dataConclusao: null,
      previsaoConclusao: null,
      latitude: null,
      longitude: null,
      cep: null,
      endereco: null,
      numero: null,
      bairro: null,
      cidade: null,
      uf: null,
      fone: null,
      fone1: null,
      contato: null,
      area: '',
      rota: null,
      tipo: null,
      tipoEdificacao: null,
      status: '1',
      origemCliente: null,
      materialDisponivel: null,
      horarioEntrega: null,
      fases: [],
      fasesItens: [],
      parcelamentos: [],
      newParcelamentos: [],
      comissoes: [],
      observacao: null,
      regiao: null,
    },

    tabParcelamento: {
      prefix: '',
      condicao: '',
      tipoVenda: undefined,
      ct: undefined,
      faseObra: null,
      valorTotal: 0.0,
      valor: 0.0,
      parcelas: [],
    },

    tabFase: {
      codigo: '',
      nomeFase: '',
    },

    tabFaseItem: {
      item: null,
      quantidade: null,
      quantidadeAplicada: null,
      valor: 0,
      tipoPreco: 0,
      seq: null,
    },

    tabAplicacao: {
      dataPrevisao: null,
      quantidade: 0,
    },

    tabComissao: {
      vendedor: null,
      percentual: null,
      tipo: null,
    },

    dialogTabParcelamento: false,
    dialogTabAplicacao: false,
    dialogTabComissao: false,
    dialogTabFase: false,
    dialogTabFaseItem: false,

    selectedParcelamento: {},
    selectedAplicacao: {},
    selectedComissao: {},
    selectedFaseItem: {},

    formValid: false,
    tabFaseValid: false,
    tabFaseItemValid: false,
    tabAplicacaoValid: false,
    tabComissaoValid: false,
    tabParcelamentoValid: false,

    isLoading: true,
    isUpdate: false,
  }),

  computed: {
    ...mapState('itemModule', ['typePriceFieldname', 'typeCurrencyFieldname']),
    ...mapGetters({
      cityList: 'cityModule/getCityList',
      itemList: 'itemModule/getComboBoxList',
      usersList: 'userModule/getUsersList',
      tipoList: 'constructionModule/getComboBoxTipoList',
      tipoEdificacaoList: 'constructionModule/getComboBoxTipoEdificacaoList',
      origemClienteList: 'constructionModule/getComboBoxOrigemClienteList',
      statusList: 'constructionModule/getComboBoxStatusList',
      companyList: 'companyModule/getComboBoxList',
    }),

    selectedFase() {
      /*
        -- selectedFases é para poder marcar quais fases vão gerar um parcelamento

        selectedFase sempre será o ultimo item da lista "selectedFases"
        Isto é para poder exibir os dados de aplicação, comissão
      */

      const last = this.selectedFases.length - 1

      return last > -1 ? this.selectedFases[last] : {}
    },

    typePriceList() {
      return this.typePriceFieldname.map((item, index) => ({
        // PRECOVAREJO = Varejo
        descricao: item[5] + item.substring(6).toLowerCase(),
        id: index,
      }))
    },

    cmpPrecoItemPeloTipo() {
      if (this.tabFaseItem.item) {
        const tipoPreco = this.tabFaseItem.tipoPreco
          ? parseInt(this.tabFaseItem.tipoPreco)
          : 0
        const produto = this.tabFaseItem.item
        let preco = produto[this.typePriceFieldname[tipoPreco]]

        this.formatValuesByTypeCurrency(tipoPreco, produto, preco ?? 0)
        return preco ?? 0
      }
      return 0
    },

    cmpTotalFaseItem() {
      if (this.tabFaseItem.item) {
        const tipoPreco = this.tabFaseItem.tipoPreco
          ? parseInt(this.tabFaseItem.tipoPreco)
          : 0
        const produto = this.tabFaseItem.item
        let preco = produto[this.typePriceFieldname[tipoPreco]]

        let total =
          this.tabFaseItem.quantidade > 0
            ? parseFloat(this.tabFaseItem.quantidade) * parseFloat(preco)
            : 0

        this.formatValuesByTypeCurrency(tipoPreco, produto, total)
        return total
      }
      return 0
    },

    totalObra() {
      const total = this.form.fasesItens.reduce((total, faseItem) => {
        let soma = parseFloat(faseItem.QUANTIDADE) * parseFloat(faseItem.VALOR)
        return (total += soma)
      }, 0.0)

      return total
      // return this.formatCurrency(0, parseFloat(total), 'decimal')
    },

    totalFase() {
      const total = this.form.fasesItens
        .filter((current) => current.FASE == this.selectedFase.FASE)
        .reduce((total, faseItem) => {
          let soma =
            parseFloat(faseItem.QUANTIDADE) * parseFloat(faseItem.VALOR)
          return (total += soma)
        }, 0.0)

      return total
      // return this.formatCurrency(0, parseFloat(total), 'decimal')
    },

    headerOrcamentos() {
      return [
        { text: 'Data', value: 'DATA', align: 'start', width: 50 },
        { text: 'Hora', value: 'HORA', align: 'start' },
        { text: 'Número', value: 'NUMERO', align: 'start' },
        { text: 'Serie', value: 'SERIE', align: 'start', width: 50 },
        { text: 'Fase', value: 'FASE', align: 'start' },
        { text: 'Valor', value: 'VALOR', align: 'end' },
        { text: 'Custo Total', value: 'VALOR', align: 'end' },
        { text: 'Vlr. Desconto', value: 'VALORDESCONTOUNIT', align: 'end' },
        { text: 'Liberado', value: 'LIBERADO', align: 'start' },
      ]
    },

    headerParcelamentos() {
      return [
        { text: 'Data', value: 'DATA', align: 'start', width: 50 },
        { text: 'Hora', value: 'HORA', align: 'start' },
        { text: 'Documento', value: 'DOCUMENTO', align: 'start' },
        { text: 'Valor', value: 'VALOR' },
        { text: 'Valor Pago', value: 'VALORPAGO' },
        { text: 'Pendente', value: 'PENDENTE' },
        { text: 'Ações', value: 'controls' },
      ]
    },

    headerItensOrcamento() {
      return [
        { text: 'Código', value: 'ITEM', align: 'start' },
        { text: 'Descrição', value: 'item.DESCRICAO', align: 'start' },
        { text: 'Quantidade', value: 'QUANTIDADE', align: 'start' },
        { text: 'Valor', value: 'PRECO', align: 'start' },
        { text: 'Valor Desconto', value: 'VALORDESCONTO', align: 'start' },
        { text: 'Valor Total', value: 'VALORTOTAL', align: 'start' },
      ]
    },

    headerFases() {
      return [
        { text: 'Código', value: 'FASE', width: 50 },
        { text: 'Nome', value: 'NOMEFASE', width: 400, align: 'start' },
        { text: 'Tipo', value: 'TIPO', align: 'start' },
        { text: 'Ações', value: 'controls', align: 'right', sortable: false },
      ]
    },

    headerComissoes() {
      return [
        { text: 'Fase', value: 'FASE', width: 50 },
        { text: 'Código', value: 'VENDEDOR' },
        { text: 'Vendedor', value: 'NOME' },
        { text: '% Comissão', value: 'PERCENTUAL' },
        { text: 'Tipo', value: 'TIPO', align: 'center' },
        { text: 'Ações', value: 'controls', align: 'right', sortable: false },
      ]
    },
    headerFaseItens() {
      return [
        { text: 'Código', value: 'CODIGO', width: 50 },
        { text: 'Descrição', value: 'PRODUTO', width: 200 },
        { text: 'Quantidade', value: 'QUANTIDADE' },
        { text: 'Tipo Preço', value: 'TIPOPRECO' },
        { text: 'Valor', value: 'VALOR', align: 'end' },
        { text: 'Valor Total', value: 'calculated', align: 'end' },
        { text: 'Qtd. Aplicada', value: 'QUANTIDADEAPLICADA' },
        { text: 'Ordem', value: 'SEQ' },
        { text: 'Ações', value: 'controls', align: 'right', sortable: false },
      ]
    },

    headerAplicacao() {
      return [
        { text: 'Código', value: 'CODIGO', align: 'start' },
        { text: 'Previsão', value: 'DATA', align: 'start' },
        { text: 'Quantidade', value: 'QUANTIDADE', align: 'start' },
        { text: 'Ações', value: 'controls', align: 'right', sortable: false },
      ]
    },
    indexedComissoesList() {
      return this.form.comissoes
        .filter((comissao) => comissao.FASE === this.selectedFase.FASE)
        .map((comissao, index) => ({
          ...comissao,
          vendedor: comissao.vendedor ?? null,
          NOME: comissao.vendedor ? comissao.vendedor.NOME : '',
          id: index,
        }))
    },

    indexedFasesList() {
      return this.form.fases.map((item, index) => ({
        ...item,
        id: index,
      }))
    },

    indexedFasesItensList() {
      return this.form.fasesItens
        .filter((item) => item.FASE === this.selectedFase.FASE)
        .map((item, index) => ({
          ...item,
          PRODUTO: item.item.DESCRICAO,
          id: index,
        }))
    },

    indexedAplicacaoList() {
      let list = []
      if (this.selectedFaseItem && this.selectedFaseItem.aplicacao) {
        list = this.selectedFaseItem.aplicacao
        list = list.map((item, index) => ({
          ...item,
          id: index,
        }))
      }
      return list
    },
  },

  methods: {
    async submitForm() {
      if (!this.$refs.form.validate()) {
        this.$toasted.error('Verifique os campos em vermelho.')
        return
      }
      try {
        this.setMessage('Enviando registro para o sistema');
        this.showLoadingDialog(true);
        let response
        if (!this.isUpdate) {
          response = await this.insert(this.form)
        } else {
          response = await this.update({
            ...this.form,
            id: this.$route.params.id,
          })
        }
        this.$toasted.success(response)
        this.showLoadingDialog(false);
        this.goBack()
      } catch (error) {
        this.$toasted.error(error, { duration: null })
        this.showLoadingDialog(false);
      }
    },

    ...mapActions({
      insert: 'constructionModule/insertConstruction',
      update: 'constructionModule/updateConstruction',
    }),

    ...mapActions('constructionModule', [
      'getAllConstructions',
      'getConstruction',
    ]),
    ...mapActions('userModule', ['getUsersAPI']),
    ...mapActions('accountsModule', ['getAccounts']),
    ...mapActions('cityModule', ['getCities']),
    ...mapActions('itemModule', ['getItens', 'getItem']),
    ...mapActions('companyModule', ['getCompany', 'getCompanies']),
    ...mapActions('paymentConditionsModule', ['getPaymentConditionsAPI']),
    ...mapActions('parcelModule', ['deleteParcel']),
    ...mapActions({
      showLoadingDialog: 'dialogModule/setShowLoadingDialog',
      setMessage: 'dialogModule/setLoadingDialogMessage'
    }),
    getPrecision() {
      let isGuarani = this.getCurrencies[0].cifrao.toLowerCase() == 'g$'
      return !isGuarani ? 2 : ''
    },

    newParcel() {
      if (!this.validateSelectedFase()) return

      let errorMessage = ''

      // verificar se existem fases selecionadas com SEQUENCIALRELACIONAMENTO !== null
      let hasParcels = this.selectedFases.filter(
        (fase) => fase.SEQUENCIALRELACIONAMENTO !== null
      )

      // obter o número das fases selecionadas e seus valores para parcelar
      let totalGeral = 0.0
      let fasesParceladas = []
      for (let index = 0; index < this.selectedFases.length; index++) {
        const element = this.selectedFases[index]
        fasesParceladas = fasesParceladas.concat(element.FASE)

        const total = this.form.fasesItens
          .filter((current) => current.FASE == element.FASE)
          .reduce((total, faseItem) => {
            let soma =
              parseFloat(faseItem.QUANTIDADE) * parseFloat(faseItem.VALOR)
            return (total += parseFloat(soma.toFixed(2)))
          }, 0.0)

        totalGeral += total
      }

      if (hasParcels.length > 0) {
        errorMessage = `Fase ${hasParcels[0].FASE} já faturada.`
      } else if (totalGeral <= 0) {
        errorMessage = `Fase(s) selecionada(s) com valor total igual a Zero (0,00)`
      }

      if (errorMessage.length > 0) {
        this.$toasted.error(errorMessage)
        return
      }

      this.closeTabParcelamento()
      const totalParcelamento = parseFloat(totalGeral.toFixed(2))
      this.tabParcelamento.valorTotal = totalParcelamento
      this.tabParcelamento.valor = totalParcelamento
      this.tabParcelamento.parcela_fases = fasesParceladas
    },

    formatDateFromDB(value) {
      let date = null
      if (value) {
        if (value.lastIndexOf(' ') !== -1) {
          date = value + '-03:00'
        } else {
          date = value + ' 00:00:00-03:00'
        }
        date = new Date(date).toLocaleDateString('pt-BR')
      }
      return date
    },

    formatValuesByTypeCurrency(typePrice, item, value) {
      // quando provem de uma lista do backend vem .item no array
      let itemSearch = item.item ? item.item : item

      // o item tem a moeda em que o preço foi cadastrado
      let currencyId = itemSearch[this.typeCurrencyFieldname[typePrice]]

      this.setPreffixCurrency(currencyId)

      return this.formatCurrency(currencyId, value)
    },

    setPreffixCurrency(value) {
      this.tabFaseItem.preffix = this.getCurrencies[value].cifrao ?? ''
    },

    async isDelete(message = null) {
      let result = false
      if (
        await this.$refs.confirm.open(
          'Exclusão',
          message ?? `Deseja realmente eliminar o registro?`,
          { color: 'red' }
        )
      ) {
        result = !result
      }
      return result
    },

    getDescricaoFase(value) {
      let fase = this.form.fases.filter((current) => current.FASE === value)
      return fase[0].NOMEFASE
    },

    multiplicar(quantidade, valor) {
      return parseFloat(quantidade) * parseFloat(valor)
    },

    formatDecimalValues(value) {
      const formatted = this.formatCurrency(0, value)
      return formatted.replace(/[^0-9,.]/g, '')
    },

    formatValues(value, sequence, isOrderSequence = false) {
      if (sequence && sequence !== undefined) {
        let currencyId = -1
        if (isOrderSequence) {
          let order = this.form.orcamentos.filter(
            (current) => current.SEQUENCIAL === sequence
          )
          currencyId = order[0].MOEDA
        } else {
          currencyId = sequence
        }

        return this.formatCurrency(currencyId, value)
      } else {
        return this.formatCurrency(0, value)
      }
    },

    closeTabParcelamento() {
      this.tabParcelamento = {
        prefix: '',
        tipoVenda: undefined,
        condicao: '',
        ct: undefined,
        faseObra: null,
        valorTotal: 0.0,
        valor: 0.0,
        parcelas: [],
      }
      this.dialogTabParcelamento = !this.dialogTabParcelamento
    },

    closeTabComissao() {
      this.tabComissao = {
        vendedor: null,
        tipo: null,
        percentual: null,
      }
      this.dialogTabComissao = !this.dialogTabComissao
    },

    closeTabFase() {
      this.tabFase = {
        codigo: null,
        nomeFase: null,
      }
      this.dialogTabFase = !this.dialogTabFase
    },

    closeTabFaseItem() {
      this.tabFaseItem = {
        preffix: '',
        quantidade: null,
        quantidadeAplicada: null,
        tipoPreco: 0,
        valor: null,
        seq: null,
        item: null,
      }
      this.dialogTabFaseItem = !this.dialogTabFaseItem
    },

    validateSelectedFase() {
      let result = true
      if (!this.selectedFase.FASE) {
        this.$toasted.error('Selecione uma fase primeiro.')
        result = false
      }
      return result
    },

    async addComissao() {
      if (!this.validateSelectedFase()) return

      if (!this.$refs.formComissao.validate()) return

      if (this.tabComissao && this.tabComissao.vendedor) {
        if (this.tabComissao.id >= 0)
          await this.deleteComissao(this.tabComissao)

        let comissao = {
          vendedor: this.tabComissao.vendedor,
          VENDEDOR: this.tabComissao.vendedor.CODIGO,
          PERCENTUAL: this.tabComissao.percentual,
          TIPO: this.tabComissao.tipo,
          FASE: this.selectedFase.FASE,
        }

        this.form.comissoes.push(comissao)
        this.closeTabComissao()
      }
    },

    updateTabComissao(value) {
      this.tabComissao = {
        id: value.id,
        vendedor: value.vendedor,
        percentual: parseFloat(value.PERCENTUAL),
        tipo: value.TIPO,
      }
      this.dialogTabComissao = !this.dialogTabComissao
    },

    updateTabFase(value) {
      this.tabFase = {
        id: value.id,
        codigo: value.FASE,
        nomeFase: value.NOMEFASE,
      }
      this.dialogTabFase = !this.dialogTabFase
    },

    updateTabAplicacao(value) {
      this.tabAplicacao = {
        id: value.id,
        dataPrevisao: value.DATA.substring(0, 10),
        quantidade: parseFloat(value.QUANTIDADE),
      }
      this.dialogTabAplicacao = !this.dialogTabAplicacao
    },

    async updateTabFaseItem(value) {
      try {
        let item = await this.getItem(value.item.CODIGO)
        this.produtoList.push(item)

        this.tabFaseItem = {
          id: value.id,
          quantidade: parseFloat(value.QUANTIDADE),
          quantidadeAplicada: parseFloat(value.QUANTIDADEAPLICADA),
          tipoPreco: parseInt(value.TIPOPRECO),
          valor: parseFloat(value.VALOR),
          seq: value.SEQ,
          item: item,
          preffix: '',
        }
        this.dialogTabFaseItem = !this.dialogTabFaseItem
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },

    async addAplicacao() {
      if (!this.$refs.formAplicacao.validate()) return

      if (this.tabAplicacao) {
        let msg = ''

        if (this.tabAplicacao.dataPrevisao < this.form.data) {
          msg = 'Data previsão da aplicação é menor que data da obra.'
          this.$toasted.error(msg, { duration: null })
          return
        }

        let qtd = this.selectedFaseItem.aplicacao
          ? this.selectedFaseItem.aplicacao.reduce((total, item) => {
              return (total += parseFloat(item.QUANTIDADE))
            }, 0.0)
          : 0

        qtd += parseFloat(this.tabAplicacao.quantidade)
        let qtdItem = parseFloat(this.selectedFaseItem.QUANTIDADE)

        if (qtd > qtdItem) {
          msg = `Quantidade não bate com o item.\n Quantidade Item: ${qtdItem}.\n Quantidade Prevista: ${qtd}`
          this.$toasted.error(msg, { duration: null })
          return
        }

        if (this.tabAplicacao.id >= 0)
          await this.deleteAplicacao(this.tabAplicacao)

        let aplicacao = this.indexedAplicacaoList.filter(
          (aplicacao) =>
            aplicacao.CODIGO == this.selectedFaseItem.CODIGO &&
            aplicacao.FASE == this.selectedFaseItem.FASE &&
            aplicacao.DATA == this.tabAplicacao.DATA
        )

        if (aplicacao.length > 0) {
          msg = 'Já existe uma previsão para a data informada.'
          this.$toasted.error(msg)
          return
        }

        aplicacao = {
          CODIGO: this.selectedFaseItem.CODIGO,
          FASE: this.selectedFaseItem.FASE,
          DATA: this.tabAplicacao.dataPrevisao,
          QUANTIDADE: this.tabAplicacao.quantidade,
        }

        if (this.selectedFaseItem.aplicacao) {
          this.selectedFaseItem.aplicacao.push(aplicacao)
          this.form.fasesItens[
            this.selectedFaseItem.id
          ].aplicacao = this.selectedFaseItem.aplicacao
        } else {
          let faseItem = {
            ...this.selectedFaseItem,
            aplicacao: [],
          }

          this.selectedFaseItem = faseItem
          this.selectedFaseItem.aplicacao.push(aplicacao)
          this.form.fasesItens[this.selectedFaseItem.id] = this.selectedFaseItem
        }
        this.closeTabAplicacao()
      }
    },

    closeTabAplicacao() {
      this.tabAplicacao = {
        dataPrevisao: null,
        quantidade: 0,
      }
      this.dialogTabAplicacao = !this.dialogTabAplicacao
    },

    async deleteParcelamento(value, isAutoDelete = true) {
      if (!isAutoDelete) {
        if (
          !(await this.isDelete(
            'Deseja realmente cancelar o parcelamento da fase selecionada?'
          ))
        )
          return

        try {
          const response = await this.deleteParcel(value.SEQUENCIALPARCELA)

          if (!response) return

          if (this.form.parcelamentos.length > 0) {
            let parcelas = this.form.parcelamentos.filter(
              (v) => v.SEQUENCIALPARCELA !== value.SEQUENCIALPARCELA
            )

            this.form.parcelamentos = parcelas
          }

          let fases = this.form.fases.map((item) => ({
            ...item,
            SEQUENCIALRELACIONAMENTO:
              item.SEQUENCIALRELACIONAMENTO == value.SEQUENCIALPARCELA
                ? null
                : item.SEQUENCIALRELACIONAMENTO,
            USUARIOLIBEROU:
              item.SEQUENCIALRELACIONAMENTO == value.SEQUENCIALPARCELA
                ? null
                : item.USUARIOLIBEROU,
            DATALIBERACAO:
              item.SEQUENCIALRELACIONAMENTO == value.SEQUENCIALPARCELA
                ? null
                : item.DATALIBERACAO,
          }))

          this.form.fases = fases

          if (this.selectedFase) {
            if (
              this.selectedFase.SEQUENCIALRELACIONAMENTO ==
              value.SEQUENCIALPARCELA
            ) {
              this.selectedFase.SEQUENCIALRELACIONAMENTO = null
              this.selectedFase.USUARIOLIBEROU = null
              this.selectedFase.DATALIBERACAO = null
            }
          }
        } catch (error) {
          this.$toasted.error(error, { duration: null })
        }
      }

      try {
        if (this.form.newParcelamentos) {
          let newParcelas = this.form.newParcelamentos.slice()

          newParcelas = newParcelas
            .map(function(current) {
              if (current) {
                for (
                  let index = 0;
                  index < current.parcela_fases.length;
                  index++
                ) {
                  const item = current.parcela_fases[index]
                  value.parcela_fases.indexOf(item)
                  let removeItem = value.parcela_fases.indexOf(item)
                  if (removeItem != -1) {
                    return 'eliminar'
                  } else {
                    return current
                  }
                }
              }
            })
            .filter((current) => current !== 'eliminar')

          this.form.newParcelamentos = newParcelas
        }
      } catch (error) {
        console.log('erro delete parcelamento', error)
      }
    },

    async addParcelamento() {
      if (!this.selectedFase) {
        this.$toasted.error('Selecione uma fase primeiro.')
      }

      if (!this.tabParcelamentoValid) return

      if (this.tabParcelamento && this.tabParcelamento.parcelas.length > 0) {
        // eliminar visualmente as parcelas (q estão no banco) e a lista newParcelamentos(se houver)
        await this.deleteParcelamento({
          parcela_fases: this.tabParcelamento.parcela_fases,
        })

        if (this.form.newParcelamentos) {
          let newParcelas = this.form.newParcelamentos
          Array.prototype.push.apply(newParcelas, this.tabParcelamento.parcelas)
        } else {
          this.form.newParcelamentos = this.tabParcelamento.parcelas
        }

        this.closeTabParcelamento()
      }
    },

    async addFase() {
      if (!this.$refs.formFase.validate()) return

      if (this.tabFase && this.tabFase.nomeFase.trim().length > 0) {
        if (this.tabFase.id >= 0) {
          await this.deleteFase(this.tabFase)
        } else {
          let arr = this.form.fases.map((f) => f.FASE)
          let max = arr.length > 0 ? Math.max.apply(null, arr) : 0
          this.tabFase.codigo = max + 1
        }

        let fase = {
          id: this.tabFase.id,
          FASE: this.tabFase.codigo,
          NOMEFASE: this.tabFase.nomeFase,
        }

        this.form.fases.push(fase)
        this.closeTabFase()
      }
    },

    async addFaseItem() {
      if (!this.$refs.formFaseItem.validate()) return

      if (!this.selectedFase) {
        this.$toasted.error('Selecione uma fase primeiro.')
      }

      if (this.tabFaseItem.item && this.selectedFase) {
        if (this.tabFaseItem.quantidadeAplicada > this.tabFaseItem.quantidade) {
          let msg = `Quantidade não bate com o item.\n Quantidade Item: ${this.tabFaseItem.quantidade}.\n Quantidade Aplicada: ${this.tabFaseItem.quantidadeAplicada}`
          this.$toasted.error(msg, { duration: null })
          return
        }

        if (this.tabFaseItem.id >= 0)
          await this.deleteFaseItem(this.tabFaseItem)

        let faseItem = {
          FASE: this.selectedFase.FASE,
          QUANTIDADE: this.tabFaseItem.quantidade,
          VALOR: parseFloat(this.cmpPrecoItemPeloTipo.replace(/[^0-9,.]/g, '')),
          SEQ: this.tabFaseItem.seq,
          TIPOPRECO: parseInt(this.tabFaseItem.tipoPreco),
          QUANTIDADEAPLICADA: this.tabFaseItem.quantidadeAplicada,
          item: this.tabFaseItem.item,
          CODIGO: this.tabFaseItem.item.CODIGO,
        }

        this.form.fasesItens.push(faseItem)
        this.closeTabFaseItem()
      }
    },

    async deleteComissao(value, isAutoDelete = true) {
      if (!isAutoDelete) {
        if (!(await this.isDelete())) return
      }

      let comissoes = this.indexedComissoesList.filter((v) => v.id !== value.id)
      this.form.comissoes = comissoes
    },

    async deleteAplicacao(value, isAutoDelete = true) {
      if (!isAutoDelete) {
        if (!(await this.isDelete())) return
      }

      let aplicacoes = this.indexedAplicacaoList.filter(
        (v) => v.id !== value.id
      )

      // sobrepor a lista original e o selecionado
      this.form.fasesItens[this.selectedFaseItem.id].aplicacao = aplicacoes
      this.selectedFaseItem.aplicacao = aplicacoes
    },

    async deleteFase(value, isAutoDelete = true) {
      if (!isAutoDelete) {
        if (!(await this.isDelete())) return
      }

      if (value.SEQUENCIALRELACIONAMENTO > 0) {
        this.$toasted.error(
          'Fase possui parcelamento. Não é possível continuar.'
        )
        return
      }

      let fases = this.indexedFasesList.filter((v) => v.id !== value.id)

      this.form.fases = fases
    },

    async deleteFaseItem(value, isAutoDelete = true) {
      if (!isAutoDelete) {
        if (!(await this.isDelete())) return
      }

      let fasesItens = this.indexedFasesItensList.filter(
        (v) => v.id !== value.id
      )
      this.form.fasesItens = fasesItens
    },

    selectComissao(event) {
      if (event.value === true) {
        this.selectedComissao = event.item
      } else {
        this.selectedComissao = null
      }
    },

    selectAplicacao(event) {
      if (event.value === true) {
        this.selectedAplicacao = event.item
      } else {
        this.selectedAplicacao = null
      }
    },

    selectFaseItem(event) {
      if (event.value === true) {
        this.selectedFaseItem = event.item
      } else {
        this.selectedFaseItem = {}
      }
    },

    search($event, property) {
      try {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          let param = $event.target.value ?? null

          if (!param || param.trim().length <= 0) return

          let payload = { page: 1 }

          if (param.lastIndexOf('-') == -1) {
            payload.hibrido = param
          } else {
            param = param
              .trim()
              .split('-')[0]
              .trim()

            payload.codigo = parseInt(param)
          }

          let fnc = this.getCompanies
          let list = 'companyList'

          if (!this.form[property] || this.form[property].CODIGO == param) {
            this.getDados(payload, property, fnc, list)
          }
        }, 600)
      } catch (error) {
        console.log('erro search', error)
      }
    },

    async getDados(payload, property, fnc, ownerList) {
      try {
        await fnc(payload)
        this[`${property}List`] = this[ownerList]
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },

    updateUF(value) {
      if (value && value.UF && value.UF.length > 0) {
        this.form.uf = value.UF
      }
    },

    searchItems($event, property) {
      try {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          let param = $event && $event.target.value ? $event.target.value : null
          let payload = {
            query: undefined,
            type: 'item',
          }

          payload.query = parseInt(param)
            ? { page: 1, codigo: parseInt(param) }
            : { page: 1, descricao: param }

          if (
            !this.form[property] ||
            parseInt(param) !== this.form[property].CODIGO
          ) {
            this.getDados(payload, property, this.getItens, 'itemList')
          }
        }, 600)
      } catch (error) {
        console.log('erro searchItems', error)
      }
    },

    searchCity(value) {
      if (!value) return

      try {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          let param = value

          let payload = parseInt(param)
            ? { page: 1, codigo: parseInt(param) }
            : { page: 1, descricao: param }

          if (
            !this.form.cidade ||
            parseInt(param) !== this.form.cidade.CODIGO
          ) {
            this.getDados(payload, 'cidade', this.getCities, 'cityList')
          }
        }, 600)
      } catch (error) {
        console.log('erro searchCity', error)
      }
    },

    async setData() {
      await this.fetch()
      try {
        if (this.$route.params) {
          if (this.$route.params.id > 0) {
            let construction = await this.getConstruction(this.$route.params.id)
            this.isUpdate = !this.isUpdate

            if (construction.empresa)
              this.empresaList.push({
                ...construction.empresa,
                DESCRICAO:
                  construction.empresa.CODIGO +
                  ' - ' +
                  construction.empresa.NOME,
              })
            if (construction.arquiteto)
              this.arquitetoList.push({
                ...construction.empresa,
                DESCRICAO:
                  construction.arquiteto.CODIGO +
                  ' - ' +
                  construction.arquiteto.NOME,
              })
            if (construction.engenheiro)
              this.engenheiroList.push({
                ...construction.engenheiro,
                DESCRICAO:
                  construction.engenheiro.CODIGO +
                  ' - ' +
                  construction.engenheiro.NOME,
              })

            if (construction.cidade && construction.cidade.DESCRICAO.length > 0)
              this.cidadeList.push({
                ...construction.cidade,
                DESCRICAO:
                  construction.cidade.DESCRICAO +
                    ' - ' +
                    construction.cidade.UF ?? '',
              })

            // somente enquanto não busca região e rota do backend
            if (construction.rota) this.rotaList.push(construction.rota)
            if (construction.regiao) this.regiaoList.push(construction.regiao)

            this.form = {
              ...construction,
            }
          }
        }
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },

    async fetch() {
      try {
        await this.getUsersAPI({ todos: 'S' })
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
  },
  async created() {
    await this.setData()
    this.isLoading = !this.isLoading
  },
}
</script>

<style lang="css" scoped>
.unstyled::-webkit-inner-spin-button,
.unstyled::-webkit-outer-spin-button,
.unstyled::-webkit-clear-button {
  -webkit-appearance: none;
  display: none;
}
.unstyled::-webkit-calendar-picker-indicator {
  -webkit-appearance: none;
  display: none;
}
input[type='date']::-webkit-inner-spin-button,
input[type='date']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  display: none;
}
.customClass >>> label {
  font-size: 0.8em;
}
</style>
